<template>
  <div>
    <b-modal
        id="modal-create-report"
        ref="modal-create-report"
        no-close-on-backdrop
        footer-class="flex-nowrap"
        centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.createReport.title') }}</h3>
      </template>

      <template #default>
        <div class="mt-4 mx-5 mb-3">
          <b-form-input
              v-model="reportName"
              :placeholder="$t('modals.createReport.name')"
              @update="setName"
              autofocus
              debounce="500"
              @keyup.enter="createReport"
          >
          </b-form-input>
        </div>
        <div class="mx-5 mb-4">
          <b-form-input
              v-model="reportDescription"
              :placeholder=" $t('modals.createReport.description') "
              @update="setDescription"
              debounce="500"
              @keyup.enter="createReport"
          >
          </b-form-input>
        </div>
      </template>

      <template #modal-footer>
        <b-button
            class="p-3 border-right-light-grey"
            block
            @click="$emit('cancel')"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
            :disabled="!isReportNameSet"
            variant="primary"
            class="p-3"
            block
            @click="createReport"
        >
          {{ $t('modals.createReport.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalCreateNewReport',
  data: () => ({
    reportName: null,
    reportDescription: null,
  }),
  computed: {
    isReportNameSet() {
      return !!this.reportName;
    },
  },
  mounted() {
    this.$refs['modal-create-report'].show();
  },
  methods: {
    setName(value) {
      this.$emit('update-fields', 'teamName', value);
    },
    setDescription(value) {
      this.$emit('update-fields', 'teamDescription', value);
    },
    async createReport() {
      if (this.isReportNameSet) {
        this.$emit('create-report', { name: this.reportName, desc: this.reportDescription });
        this.$refs['modal-create-report'].hide();
      }
    },
  },
};
</script>

<style scoped>

</style>
